<template>
  <div>
    <div v-if="!loading" class="">
      <div
        v-if="success"
        class="flex flex-col items-center justify-center h-full"
      >
        <img src="/img/connections/icons/success.png" alt="Checkmark" />
        <h3 class="text-center m-4">Success!</h3>
        <p class="lg:w-1/2 text-center mb-6">
          Thank you for supporting {{ settings.profile_title }}
        </p>

        <p class="text-center text-truegray-500">
          A school administrator will review your connection and reach out if
          necessary.
        </p>
      </div>
      <div v-else class="flex flex-col items-center justify-center h-full">
        <div class="items-center justify-center text-red-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-12 h-12"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
            />
          </svg>
        </div>

        <h3 class="text-center m-4">Something went wrong</h3>
        <p class="text-center text-truegray-500">
          We were unable to find a valid token to verify your sign up. It is
          possible the link has expired.
        </p>
      </div>
    </div>
    <div v-else class="w-full h-16 flex items-center justify-center">
      <lottie :options="loadingAnimationOptions" />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from '../../../../../js/store/index.js'
import * as loadingAnimation from '../../../../../shared/components/loading-dark.json'

export default defineComponent({
  name: 'ModalAttachConnections',

  props: {
    config: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const store = useStore()
    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const loading = ref(false)
    const animating = ref(false)
    const success = ref(false)

    const settings = computed(() => store.getters['shared/getSettings'])

    const validateConnection = async () => {
      loading.value = true
      const response = await store.dispatch(
        'connections/dispatchValidateConnection',
        {
          id: props.config.id,
          token: props.config.token,
        },
      )

      animating.value = false
      loading.value = false
      success.value = response
    }

    onMounted(() => {
      validateConnection()
    })

    return {
      loadingAnimationOptions,
      loading,
      animating,
      settings,
      success,
    }
  },
})
</script>
